/**
 * Centralized API headers utility
 * Single source of truth for tenant and auth headers
 */

import { getAccessToken } from './token';

/**
 * Get tenant ID from localStorage
 * @returns The tenant ID string
 */
export const getTenantId = (): string => {
  const tenantId = localStorage.getItem('X_TENANT_ID');
  if (!tenantId) {
    console.warn('X_TENANT_ID not found in localStorage');
    return '';
  }
  return tenantId;
};

/**
 * Get standard auth headers for API requests
 * @returns Headers object with Authorization, x-tenant-id, x-user-id, x-role, and Accept
 */
export const getAuthHeaders = (): Record<string, string> => {
  const token = getAccessToken();
  const tenantId = getTenantId();
  const userId = localStorage.getItem('X_USER_ID');
  const role = localStorage.getItem('X_ROLE');

  const headers: Record<string, string> = {
    Accept: 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (tenantId) {
    headers['x-tenant-id'] = tenantId;
  }

  if (userId) {
    headers['x-user-id'] = userId;
  }

  if (role) {
    headers['x-role'] = role;
  }

  return headers;
};

/**
 * Get tenant ID fallbacks for lessons API
 * First tries the main tenant ID, then falls back to "tkm" for backward compatibility
 * @returns Array of tenant IDs to try in order
 */
export const getLessonTenantIdFallbacks = (): string[] => {
  return [getTenantId(), 'tkm'];
};